// 销售退货

export default [
    {   //销售退货计划管理端
        path: "salesreturns/planmanage",
        name: "salesreturnsPlanmanage",
        component: () => import(/* webpackChunkName: "salesreturns" */ "@/views/salesreturns/planmanage/index"),
    },
    {   //销售退货计划管理端详情
        path: "salesreturns/planmanage/detail",
        name: "salesreturnsPlanmanageDetail",
        component: () => import(/* webpackChunkName: "salesreturns" */ "@/views/salesreturns/planmanage/detail"),
    },
    {   //销售退货计划客户端
        path: "salesreturns/plancustom",
        name: "salesreturnsPlancustom",
        component: () => import(/* webpackChunkName: "salesreturns" */ "@/views/salesreturns/plancustom/index"),
    },
    {   //销售退货计划客户端详情
        path: "salesreturns/plancustom/detail",
        name: "salesreturnsPlanCustomDetail",
        component: () => import(/* webpackChunkName: "salesreturns" */ "@/views/salesreturns/plancustom/detail"),
    },
    {   //销售退货单
        path: "salesreturns/bill",
        name: "salesreturnsBill",
        component: () => import(/* webpackChunkName: "salesreturns" */ "@/views/salesreturns/bill/index"),
    },
    {   //销售退货单详情
        path: "salesreturns/bill/update/:type",
        name: "salesreturnsBillUpdate",
        component: () => import(/* webpackChunkName: "salesreturns" */ "@/views/salesreturns/bill/update"),
    },
    {   //退货处理计划管理端
        path: "salesreturns/saleshandleplanmanage",
        name: "salesHandlePlanManage",
        component: () => import(/* webpackChunkName: "salesreturns" */ "@/views/salesreturns/saleshandleplanmanage/index"),
    },
    {   //退货处理计划管理端详情
        path: "salesreturns/saleshandleplanmanage/detail",
        name: "salesHandlePlanManageDetail",
        component: () => import(/* webpackChunkName: "salesreturns" */ "@/views/salesreturns/saleshandleplanmanage/detail"),
    },
    {   //退货处理单
        path: "salesreturns/saleshandleorder",
        name: "salesHandleOrder",
        component: () => import(/* webpackChunkName: "salesreturns" */ "@/views/salesreturns/saleshandle/index"),
    },
    {   //退货处理单详情
        path: "salesreturns/saleshandleorder/detail",
        name: "salesHandleOrderDetail",
        component: () => import(/* webpackChunkName: "salesreturns" */ "@/views/salesreturns/saleshandle/detail"),
    },
    {   //认领处理单
        path: "salesreturns/claimorderhandle",
        name: "claimOrderHandle",
        component: () => import(/* webpackChunkName: "salesreturns" */ "@/views/salesreturns/claimorderhandle/index"),
    },
    {   //认领处理单详情
        path: "salesreturns/claimorderhandle/detail",
        name: "claimOrderHandleDetail",
        component: () => import(/* webpackChunkName: "salesreturns" */ "@/views/salesreturns/claimorderhandle/detail"),
    },
    {   //认领单管理端
        path: "salesreturns/claimordermanage",
        name: "claimOrderManage",
        component: () => import(/* webpackChunkName: "salesreturns" */ "@/views/salesreturns/claimordermanage/index"),
    },
    {   //认领单管理端详情
        path: "salesreturns/claimordermanage/detail",
        name: "claimOrderManageDetail",
        component: () => import(/* webpackChunkName: "salesreturns" */ "@/views/salesreturns/claimordermanage/detail"),
    },
    {   //认领单客户端
        path: "salesreturns/claimordercustom",
        name: "claimOrderCustom",
        component: () => import(/* webpackChunkName: "salesreturns" */ "@/views/salesreturns/claimordercustom/index"),
    },
    {   //认领单客户端详情
        path: "salesreturns/claimordercustom/detail",
        name: "claimOrderCustomDetail",
        component: () => import(/* webpackChunkName: "salesreturns" */ "@/views/salesreturns/claimordercustom/detail"),
    },
]

